import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import { FETCH_SECTION_LIST, FETCH_TICKET_LIST } from "../../actions/types";

import HelpAndSupportHeader from "../CommonComponents/HelpAndSupportHeader";
import HelpCard from "./HelpCard";
import HelpAndSupportFooter from "../CommonComponents/HelpAndSupportFooter";
import ErrorMessage from "../CommonComponents/ErrorMessage";

import api from "../../api/api";

import { removeDuplicates, getUnreadMessage } from "../../helpers";

class HelpMainPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scrolling: false,
      displayErrorHelp: false,
      curr_page: this.props.helpData.curr_page,
    };
  }

  /**
   * function for the tab switch between help topics and support topics
   * takes clicked tab name as argument and switch to selected tab
   * changes the display view and the css of selected tab
   */
  switchTabs = (tabName) => {
    if (tabName === "help") {
      this.setState({
        switchHelpToSupport: false,
        helpCssClass: "topic-option-help color-fdb100",
        supportCssClass: "topic-option-support color-a5a5a5",
      });
    } else {
      this.setState({
        switchHelpToSupport: true,
        helpCssClass: "topic-option-help color-a5a5a5",
        supportCssClass: "topic-option-support color-fdb100",
      });
    }
  };

  /**
   * this is for history or goback
   * write the work that is should do
   */
  goBack = () => {
    window.open("/faqclose", "_self");
  };

  /**
   * call zendesk api to get faq and the list of support tickets
   */
  loadHelpList = (categoryId) => {
    if (categoryId) {
      api
        .categoriesWiseList(this.state.curr_page, categoryId)
        .then((data) => {
          let newHelpData = {
            // next_page: data.data.next_page,
            sections: data.data,
          };
          this.props.listOfHelpSection(newHelpData);
          this.setState(
            {
              scrolling: false,
            },
            () => {
              api.displayHideLoader();
            }
          );
        })
        .catch((error) => {
          this.setState({
            displayErrorHelp: true,
            scrolling: false,
          });
          api.displayHideLoader();
          console.log(error);
        });
    }
  };
  /**
   * when scrolling start this function is called to update and load next page
   */
  loadMoreHelp = () => {
    const { categoryId } = this.props;
    this.setState(
      {
        scrolling: true,
        curr_page: this.state.curr_page + 1,
        displayErrorHelp: false,
      },
      () => {
        this.loadHelpList(categoryId);
      }
    );
  };
  /**
   * this method is triggered when loading starts and checks is it end of page or not
   * if end of page then loads more data if it has next page
   */
  scrollHelp = () => {
    const scrolling = this.state.scrolling;
    const pageHelp = this.props.helpData.next_page;

    if (scrolling) {
      return;
    }

    if (pageHelp === null) {
      return;
    }

    const secondLastElement = document.querySelector(
      ".help-support-card-container:nth-last-child(2)"
    );
    const lastOffset =
      secondLastElement.offsetTop + secondLastElement.clientHeight;
    const pageOffset = window.pageYOffset + window.innerHeight;
    const bottomOffset = 50;
    if (pageOffset > lastOffset - bottomOffset) {
      this.loadMoreHelp();
    }
  };

  /**
   * close the error popup message
   */
  errorCloseCLick() {
    if (this.state.displayErrorHelp) {
      this.setState({
        displayErrorHelp: false,
      });
    }
  }

  loadMoreSupport = (userId) => {
    this.setState(
      {
        displayErrorSupport: false,
      },
      () => {
        this.loadSupportMessage(userId);
      }
    );
  };

  /**
   * does the api calls and sends the data to the store
   * it also sets the scrolling to false
   */
  loadSupportMessage = (userId) => {
    const { helpTS } = this.props;
    if (userId != 0) {
      api
        .listOfTickets(1, userId)
        .then((data) => {
          console.log(data);
          let ticketsData = this.props.supportData.tickets.concat(
            data.data
          );
          if (this.props.newTicketAdded) {
            ticketsData = data.data;
          }
          const ticketsSets = removeDuplicates(ticketsData, "id");
          let newSupportData = {
            next_page: 1,
            tickets: ticketsSets,
            curr_page: 1,
          };
          this.props.listOfSupportTicket(newSupportData);
          this.setState(
            {
              scrolling: false,
            },
            () => {
              api.displayHideLoader();
            }
          );
        })
        .catch((error) => {
          this.setState({
            displayErrorSupport: true,
          });
          console.log(error);
        });
    }
  };

  /**
   * check if store has the data of help list categories and display
   * if not then do the api calls
   */
  componentDidMount() {
    const { categoryId, userId, userIdv2 } = this.props;
    api.displayHideLoader();
    console.log(this.props);
    if (this.props.helpData.sections.length === 0) {
      api.displayMainLoader();
      this.loadHelpList(categoryId);
      if (userIdv2) {
        this.loadMoreSupport(userIdv2);
      } else {
        this.loadMoreSupport(userId);
      }
    }
    this.scrollListner = window.addEventListener("scroll", this.scrollHelp);
  }

  componentWillReceiveProps(nextProps) {
    const { categoryId, userId, userIdv2 } = nextProps;
    const oldCategoryId = this.props.categoryId;
    if (categoryId !== oldCategoryId) {
      this.loadHelpList(categoryId);
    }

    if (userIdv2 !== this.props.userIdv2) {
      this.loadMoreSupport(userIdv2);
    } else {
      if (userId !== this.props.userId) {
        this.loadMoreSupport(userId);
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollHelp);
  }

  render() {
    const { helpTS, guestId } = this.props;
    const tickets = this.props.supportData && this.props.supportData.tickets;
    const ticketsWithoutReport = tickets.filter((tick) => {
      const { tags } = tick;
      const tagsPresent = tags.includes("report-abuse");
      return !tagsPresent;
    });
    const unread = getUnreadMessage(ticketsWithoutReport, helpTS);

    return (
      <div>
        {this.state.displayErrorHelp ? (
          <ErrorMessage onCloseClick={this.errorCloseCLick.bind(this)} />
        ) : (
          ""
        )}
        <HelpAndSupportHeader
          displayMessage={this.props.headerMessage}
          back={this.goBack.bind(this)}
        />
        <div className="body-container">
          <div className="topic-option-container">
            <div className="topic-option-help color-fdb100">Help Topics</div>
            {!guestId && (
              <Link
                replace
                to="/support"
                className="topic-option-support color-a5a5a5 color-a5a5a5"
              >
                Support Tickets {unread > 0 ? `(${unread})` : null}
              </Link>
            )}
          </div>
          {<HelpTopics helpData={this.props.helpData} />}
        </div>
        <HelpAndSupportFooter />
      </div>
    );
  }
}

const HelpTopics = (props) => {
  console.log(props);
  return (
    <div className="help-topic-container">
      <Link className="search-link" to="/search">
        Search in FAQs
      </Link>
      {props.helpData.sections.map((data) => {
        return <HelpCard key={data.id} displayData={data} />;
      })}
    </div>
  );
};

const mapStateToProps = (state, guestId) => {
  return {
    headerMessage: {
      title: "Help And Support",
      description: "Tickets and FAQs",
      backIcon: true,
      moreOptionhidden: true,
      searchOptionHidden: true,
    },
    supportData: state.supportData,
    helpData: state.helpData,
    categoryId: state.categoryId,
    userId: state.userId,
    helpTS: state.helpTS,
    userIdv2: state.userIdv2,
    guestId: state.guestId,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    listOfHelpSection: (sectionsData) => {
      dispatch({
        type: FETCH_SECTION_LIST,
        payload: sectionsData,
      });
    },

    listOfSupportTicket: (ticketData) => {
      dispatch({
        type: FETCH_TICKET_LIST,
        payload: ticketData,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HelpMainPage);



// WEBPACK FOOTER //
// ./src/components/Landing/HelpMainPage.js